import { Button, Form, FormItemProps } from 'antd'
import React from 'react'

type AntdFormCopyButtonProps = {
  from: FormItemProps['name']
  to: FormItemProps['name']
  children?: React.ReactNode
  disabled?: boolean
}

export const AntdFormCopyButton: React.FC<AntdFormCopyButtonProps> = ({
  from,
  to,
  children,
  disabled,
}) => {
  const form = Form.useFormInstance()

  const copyValue = () => {
    const fromValue = form.getFieldValue(from)
    form.setFieldValue(to, fromValue)
  }

  return <Button onClick={copyValue} size="small" disabled={disabled}>{children || 'Copy'}</Button>
}